import {useCallback, useState} from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {HeadingCarousel} from "@/components";
import {Carousel} from "@/components/Carousel";
import {ImageWithLoadSpinner} from "@/components/image-with-load-spinner";
import {useAuthStore} from "@/store/useAuth.store";
import {getFallbackGameImage} from "@assets/images/fallbackGameImage";
import useGetPublicLotteryGames from "../../../../private/Lottery/hooks/useGetPublicLotteryGames";
import styles from "./LotteryGamesCarousel.module.css";

const LotteryGamesCarousel = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const authStatus = useAuthStore(state => state.authStatus);
  const handleShowAuthModal = useAuthStore(state => state.handleShowAuthModal);

  const {games, isPending, error} = useGetPublicLotteryGames();
  const [carouselApi, setCarouselApi] = useState(null);

  const handleGameClick = useCallback(
    gameId => {
      if (authStatus === "authenticated") {
        navigate(`/lottery?gameId=${gameId}`);
      } else {
        handleShowAuthModal();
      }
    },
    [authStatus, navigate, handleShowAuthModal]
  );

  if (error || (!isPending && games.length === 0)) {
    return null;
  }

  return (
    <div
      id="lotteryGamesCarousel"
      className={styles.container}
    >
      <HeadingCarousel
        title={t("lotteryGamesTitle")}
        subtitle={t("lotteryGamesSubTitle")}
        icon="💵"
        onPrev={carouselApi?.scrollPrev}
        onNext={carouselApi?.scrollNext}
      />
      <Carousel
        onInit={setCarouselApi}
        renderItems={() =>
          isPending
            ? ["skel-1", "skel-2", "skel-3", "skel-4", "skel-5", "skel-6"].map(key => (
                <div
                  key={key}
                  className={styles.slideCell}
                >
                  <div className={styles.gameCard}>
                    <div className={styles.loadingIcon}>
                      <div className={styles.spinner} />
                    </div>
                  </div>
                </div>
              ))
            : games.map(game => (
                <div
                  key={game.uniqueId}
                  className={styles.slideCell}
                >
                  <div
                    className={styles.gameCard}
                    onClick={() => handleGameClick(game.id)}
                  >
                    <ImageWithLoadSpinner
                      src={game.logo || getFallbackGameImage()}
                      alt={game.name}
                      fallbackSrc={getFallbackGameImage()}
                      wrapperClassName={styles.gameIcon}
                      objectFit="contain"
                    />
                    <div className={styles.gameName}>{game.name}</div>
                  </div>
                </div>
              ))
        }
      />
    </div>
  );
};

export default LotteryGamesCarousel;
